import React, { useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { EaseTable } from '../../../libs/EaseTable';
import { ContentCard, PaginationKaBaap } from '../../Common';
import { handleApiExceptions, generate_query_set } from '../../../app_methods';
import { getReportsTableColumns, reportsTableFilterNodes } from './constants';
import { Report } from '../../../models';
import { connect } from 'react-redux';
import { PermissionHoc } from '../../HOC';
import { ReportDetailsDrawer } from './detail_drawer';

const TransfersList = (props) => {
    const [reports, setReports] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [pagination, setPagination] = useState({
        pageSize: 15,
        current: 1,
        hasNext: true,
        showing: { from: 1, to: 15 }
    });
    const [filters, setFilters] = useState({});
    const [showDetailsDrawer, setShowDetailsDrawer] = useState(false);
    const [selectedReport, setSelectedReport] = useState({})

    const toggleDetailsDrawer = (record={}) => {
        setSelectedReport(record);
        setShowDetailsDrawer(!showDetailsDrawer);
    }


    const prepFilters = (filters) => {
        let _filters = { ...filters };
        if (_filters.duration && _filters.duration.length) {
            _filters.duration_start_date = _filters.duration[0].format("YYYY-MM-DD");
            _filters.duration_end_date = _filters.duration[1].format("YYYY-MM-DD");
            delete _filters.duration;
        }
        return _filters;
    };

    const fetchReports = async (_pagination, _filters = filters) => {
        if (!props.current_user.key) return;
        setIsTableLoading(true);
        const response = await Report.list_v2({ pageSize: _pagination.pageSize, current: _pagination.current, ...prepFilters(_filters)});
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        setReports(generate_query_set(Report, response.data.results));
        setPagination({ ..._pagination, ...response.data.pagination });
        setIsTableLoading(false);
    };
    
    const downloadReport = async (reportObj) => {
        setIsTableLoading(true);
        const response = await reportObj.download();
        if (!response.success) {
            setIsTableLoading(false);
            handleApiExceptions(response);
            return;
        }
        setIsTableLoading(false);
        window.open(response.data.url, '_blank');
    }

    const handleTableChange = (tableInfo) => {
        if (tableInfo.trigger == "columns") return;
        let _pagination = tableInfo.pagination;
        if (tableInfo.trigger == "filters") _pagination.current = 1;
        setPagination(_pagination);
        setFilters(tableInfo.filters);
        fetchReports(_pagination, tableInfo.filters);
    };

    const tableColumns = getReportsTableColumns({downloadReport: downloadReport, toggleDetailsDrawer: toggleDetailsDrawer});

    let filterNodes = reportsTableFilterNodes(props.current_user);

    useEffect(() => {
        props.onChildMount();
        let defaultFilters = {};
        filterNodes.forEach(f => defaultFilters[f.field] = f.defaultValue);
        let _filters = { ...filters, ...defaultFilters };
        setFilters(_filters);
        fetchReports(pagination, _filters);
    }, []);

    const onPageChange = (_pagination) => {
        setPagination({ ..._pagination });
        fetchReports({ ..._pagination }, filters);
    };


    return (
        <ContentCard className="p-3">
            <EaseTable
                rowKey="id"
                loading={isTableLoading}
                data={reports}
                columns={tableColumns}
                fixedSelectable={!isMobile}
                handleTableChange={handleTableChange}
                // pagination={pagination}
                // totalRecords={pagination.total}
                filterNodes={filterNodes}
            /><PaginationKaBaap pageChange={onPageChange} pagination={pagination} />
            <ReportDetailsDrawer 
                report={selectedReport}
                visible={showDetailsDrawer}
                toggleDetailsDrawer={toggleDetailsDrawer}
            />
        </ContentCard>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
});

export default connect(mapStateToProps)(PermissionHoc(TransfersList, 'VIEW_REPORTS'));